var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*======================\n    404 page\n=======================*/\n\n.page_404 {\n  padding: 40px 0;\n  background: #fff;\n  font-family: \"Arvo\", serif;\n  height: 100vh;\n}\n\n.page_404 img {\n  width: 100%;\n}\n\n.four_zero_four_bg {\n  background-image: url(" + escape(require("../../assets/img/page-not-found.gif")) + ");\n  height: 400px;\n  background-position: center;\n}\n\n.four_zero_four_bg h1 {\n  font-size: 80px;\n}\n\n.four_zero_four_bg h3 {\n  font-size: 80px;\n}\n\n.link_404 {\n  color: #fff !important;\n  padding: 10px 20px;\n  background: #39ac31;\n  margin: 20px 0;\n  display: inline-block;\n}\n.contant_box_404 {\n  margin-top: -50px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/bharath/agira-projects/asmart/agira-intranet-ui/src/app/page-not-found/page-not-found.component.css
// module id = ../../../../../src/app/page-not-found/page-not-found.component.css
// module chunks = main